import { useCallback, useContext } from 'react';
import { Localization } from '../../../model/store/providers/Localization';
import './Section.scss';
import './GeneralSection.scss';
import { UserInfo } from '../../../model/store/providers/UserInfo';
import axios from 'axios';
import { auth0Domain, clientId, databaseName } from '../../../config';
import { toaster } from '../../../model/toast/toaster';

export type Props = {
	title: string;
}

export const GeneralSection = () => {
	const { email, emailVerified } = useContext(UserInfo.State);
	const { translations } = useContext(Localization.State);
	const {
		mainPage: {
			general: {
				title,
				email: {
					label,
					verifiedLabel,
					unverifiedLabel
				},
				resetPassword: {
					btn,
					successMessage,
					failureMessage
				}
			}
		}
	} = translations;
	const resetPassword = useCallback(() => void async function() {
		try {
			await axios.post(`https://${auth0Domain}/dbconnections/change_password`, {
				client_id: clientId,
				email,
				connection: databaseName
			}, {
				headers: {
					'Content-Type': 'application/json'
				}
			});

			toaster.success(successMessage)
		}
		catch(e) {
			console.error(e);

			toaster.error(failureMessage)
		}
	}(), [email, successMessage, failureMessage]);


	return <>
		<h1 className='section__title'>{title}</h1>
		<div className='section__body'>
			<div className='section__item'>
				<div className='general-section__left'>
					<div className=''>
						<span>{label}</span> <span className='general-section__email'>{email}</span>
					</div>
					<div className='general-section__email-verified'>
						({emailVerified ? verifiedLabel : unverifiedLabel})
					</div>
				</div>
				<span className='wedge' />
				<div className='general-section__right'>
					<span className='section__secondary-link' onClick={resetPassword}>{btn}</span>
				</div>
			</div>
		</div>
	</>;
}